import { useContext } from 'react';
import { PromptContext, type AskText } from './PromptContext';

/** ERP-themed replacement for window.prompt(): `const text = await ask({ title, label })`. */
export function usePrompt(): AskText {
  const ctx = useContext(PromptContext);
  if (!ctx) throw new Error('usePrompt must be used within PromptProvider');
  return ctx;
}
